import React from "react";
import { Link, useParams } from "react-router-dom";
import classNames from "classnames";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux'

import { useModel } from "../../../generic/model-store";
import UnitIcon from "../../course/sequence/sequence-navigation/UnitIcon.jsx";
import { ReactComponent as CheckedIcon } from "./svg/checkedIcon.svg";
import { checkBlockCompletion } from '../../../courseware/data'

function Unit({ unitId, courseId, sequenceId }) {
  const { complete, title, contentType, isElectiveUnit } = useModel("units", unitId);
  const { unitId: unitIdFromUrl, sequenceId: sequenceIdFromUrl, sectionId: routeSectionId,} = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleUnitNavigationClick = (e) => {
    e.preventDefault();

    dispatch(checkBlockCompletion(courseId, sequenceIdFromUrl, unitIdFromUrl));
    navigate(
      `/course/${courseId}/${routeSectionId}/${sequenceId}/${unitId}`
    );
  };

  return (
    <a
      href="#"
      onClick={(e) => {
        handleUnitNavigationClick(e);
      }}
      className={classNames("subNav-link", {
        active: unitId === unitIdFromUrl,
      })}
    >
      <div className="nav-title-wrap">
        <span className="course-unit-icon">{complete ? <CheckedIcon /> : <UnitIcon type={contentType} />}</span>
        <span className="nav-title">{title}</span>
        <span className="sr-only">project {complete ? 'completed' : 'not completed'}</span>
      </div>
    </a>
  );
}

export default Unit;
